import React from "react";
import { IconElement } from "../../elements/icon.element";

export function ContentBlock({ title, icon, bgColor, textColor, children }) {
  return (
    <div className={`my-4 px-4 py-4  relative rounded ${bgColor} ${textColor}`}>
      {typeof title === "string" && (
        <div className="flex items-center mb-2">
          <span className="mr-4 w-5">
            <IconElement icon={icon} />
          </span>
          <strong className={textColor}>{title}</strong>
        </div>
      )}
      <div className="ml-10">{children}</div>
    </div>
  );
}
